module.exports = __webpack_public_path__ + "static/media/MuhammadEjaz.808ca4a2.jpeg";